module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-3_BW2-p-800-b38e223babbd9d9633e9f7053ee084c4.jpg";